import { ReactNode, useState } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Missed } from '@hhgtech/icons/other'
import { useMantineTheme } from '@mantine/core'
import { ExpandedCard } from 'components/molecules/expandedCard'

import { StyledInfoContentWrapper } from './index.styled'

export type InfoType = {
  title: string
  description: string
}

export type Props = {
  heading?: string
  content?: ReactNode
  infos?: InfoType[]
}

const OvulationInfo = ({ heading, infos, content }: Props) => {
  const theme = useMantineTheme()
  const [openInfo, setOpenInfo] = useState(-1)
  return (
    <div id="calculator-info">
      <Text
        size="s4"
        weight="bold"
        style={{
          marginBottom: '1rem',
        }}
      >
        <Missed
          isSolid
          color={theme.colors.blue[8]}
          size={20}
          style={{
            verticalAlign: 'middle',
            marginRight: '0.3rem',
          }}
        />
        {heading}
      </Text>
      {content ? (
        <StyledInfoContentWrapper>
          <Text size="p3">{content}</Text>
        </StyledInfoContentWrapper>
      ) : null}
      {infos?.map((info, index) => (
        <ExpandedCard
          key={index}
          title={info.title}
          isExpand={openInfo === index}
          onChange={(value: boolean) =>
            value ? setOpenInfo(index) : setOpenInfo(-1)
          }
          contentString={info.description}
          iconPosition="right"
          style={{
            marginBottom: '1rem',
          }}
        />
      ))}
    </div>
  )
}

export { OvulationInfo }
